import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useAtom } from 'jotai';

import CheckPermissions from '@/components/CheckPermissions';
import LargeCard from '@/components/LargeCard';
import LoadingIndicator from '@/components/LoadingIndicator';
import { PERMISSIONS } from '@/constants/auth.constants';
import { PERMISSIONS_LOGIC } from '@/constants/common';
import AssetDataProviderDialog from '@/features/AdminAssetDataProviderIntegration/AssetDataProviderDialog';
import {
  assetIntegrationsAtom,
  assetIntegrationsDialogModeAtom,
  assetIntegrationsDialogOpenAtom,
  useFetchAssetIntegrations
} from '@/features/AdminAssetDataProviderIntegration/AssetDataProviderIntegration.store';

import { AssetDataProviderTable } from './AssetDataProviderTable';

const AssetDataProviderIntegration = () => {
  const [assetIntegrations] = useAtom(assetIntegrationsAtom);
  const [, setAssetIntegrationsDialogMode] = useAtom(
    assetIntegrationsDialogModeAtom
  );
  const [, setAssetIntegrationsDialogOpen] = useAtom(
    assetIntegrationsDialogOpenAtom
  );
  const { isPending } = useFetchAssetIntegrations();

  const handleClick = () => {
    setAssetIntegrationsDialogMode('create');
    setAssetIntegrationsDialogOpen(true);
  };

  if (isPending) {
    return <LoadingIndicator isLoading={isPending} />;
  }

  return (
    <LargeCard title="Data Providers">
      {assetIntegrations.length !== 0 ? (
        <AssetDataProviderTable />
      ) : (
        <Typography>No data providers found.</Typography>
      )}
      <CheckPermissions
        permissions={[PERMISSIONS.ADMIN_UPDATE, PERMISSIONS.INTERNAL]}
        logic={PERMISSIONS_LOGIC.AND}
      >
        <Stack sx={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            sx={{ mt: 2 }}
          >
            Add Provider
          </Button>
        </Stack>
        <AssetDataProviderDialog />
      </CheckPermissions>
    </LargeCard>
  );
};

export default AssetDataProviderIntegration;
